import { makeStyles } from "@fluentui/react-components";
import { ChevronDown24Regular } from "@fluentui/react-icons";
import { dolphinTokens } from "../../utils/Theme";

interface IScrollDownButtonProps {
    onClick: () => void;
}

const useStyles = makeStyles({
    scrollDownBtn: {
            position: "absolute",
            left: "50%",
            bottom: "2rem",
            transform: "translateX(-50%)",
            zIndex: 3,
            background: "rgba(255,255,255,0.85)",
            color: dolphinTokens.colorDarkBlue,
            border: "none",
            borderRadius: "2rem",
            padding: "0.5rem 1.5rem",
            fontWeight: 600,
            fontSize: "1rem",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            display: "none",
            alignItems: "center",
            gap: "0.5rem",
            transition: "background 0.2s",
            
            "&:hover": {
                background: "#e6f0fa",
            }
        },
        scrollDownIcon: {
            fontSize: "1.5rem",
        }
});

export const ScrollDownButton = (props: IScrollDownButtonProps) => {
    const styles = useStyles();

    return (
        <button className={styles.scrollDownBtn} onClick={props.onClick} aria-label="Scroll Down">
            <ChevronDown24Regular className={styles.scrollDownIcon} />
        </button>
    );
}